import { useNotificationStore } from "@stores/notification.store";
import { useThemeStore } from "@stores/theme.store";
import { toRp } from "@utils/helper";

import moment from "moment";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const LaundryDataDetailPage = () => {
  const { state } = useLocation();
  const { setFooter, setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setFooter(false);
    setHeader({
      type: "small",
      title: "Detail Laundry",
      buttonBack: true,
      avatar: true,
    });
    setAppBar({ title: "Detail Laundry", leading: "back" });
  }, [setFooter, setHeader, setAppBar]);

  return (
    <>
      <div className="card card-style">
        <div className="content d-flex flex-column mb-0">
          <div className="color-highlight">Status Laundry</div>
          <div className="color-theme mb-3">
            {state.selesai === "Y"
              ? "Sudah Selesai"
              : state.selesai === "N"
              ? "Belum Selesai"
              : "-"}
          </div>
          <div className="color-highlight">Tanggal</div>
          <div className="color-theme mb-3">
            {moment(state.tanggal_datang ?? Date.now()).format(
              "dddd, DD MMMM YYYY"
            )}
          </div>

          <div className="color-highlight">Berat</div>
          <div className="color-theme mb-3">{state.berat ?? "-"} kg</div>
          <div className="color-highlight">Nominal</div>
          <div className="color-theme mb-3">{toRp(state?.nominal) ?? "-"}</div>
          {state.selesai === "Y" && (
            <>
              <div className="color-highlight">Tanggal Selesai</div>
              <div className="color-theme mb-3">
                {moment(state.tanggal_selesai ?? Date.now()).format(
                  "dddd, DD MMMM YYYY"
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};
